<template>
     <span>

           <v-row>
    <v-col cols="12" sm="12" >


        <four-ways-to-improve-your-Stadia-connection v-if="articleId.toLowerCase() === '4-ways-to-improve-your-stadia-connection'"></four-ways-to-improve-your-Stadia-connection>
        <how-to-register-a-stadia-account-from-unsupported-country v-if="articleId.toLowerCase() === 'how-to-register-a-stadia-account-from-unsupported-country'"></how-to-register-a-stadia-account-from-unsupported-country>
        <how-to-register-a-stadia-account v-if="articleId.toLowerCase() === 'how-to-register-a-stadia-account'"></how-to-register-a-stadia-account>
        <how-to-play-destiny-2-on-stadia-without-subscription-from-unsupported-country v-if="articleId.toLowerCase() === 'how-to-play-destiny-2-on-stadia-without-subscription-from-unsupported-country'"></how-to-play-destiny-2-on-stadia-without-subscription-from-unsupported-country>
        <how-to-access-stadia-from-unsupported-country-on-chrome-cast-ultra v-if="articleId.toLowerCase() === 'how-to-access-stadia-from-unsupported-country-on-chrome-cast-ultra'"></how-to-access-stadia-from-unsupported-country-on-chrome-cast-ultra>
        <how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv v-if="articleId.toLowerCase() === 'how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv'"></how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv>

    </v-col>



  </v-row>

        </span>
</template>

<script>


import FourWaysToImprove from './articles/4-ways-to-improve-your-Stadia-connection';
import HowToRegisterAStadiaAccountFromUnsupportedCountry from './articles/how-to-register-a-stadia-account-from-unsupported-country';
import HowToRegisterAStadiaAccount from './articles/how-to-register-a-stadia-account';
import HowToPlayDestiny2OnStadiaWithoutSubscription from './articles/how-to-play-destiny-2-on-stadia-without-subscription';
import HowToAccessStadiaFromUnsupportedCountryOnChromeCaseUltra from './articles/how-to-access-stadia-from-unsupported-country-on-chrome-cast-ultra';
import HowToAccessStadiaFromUnsupportedCountryOniOS from './articles/how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv';

  export default {
    name: 'FAQ',
      props:['articleId'],
      components: {
        'how-to-play-destiny-2-on-stadia-without-subscription-from-unsupported-country': HowToPlayDestiny2OnStadiaWithoutSubscription,
        'four-ways-to-improve-your-Stadia-connection': FourWaysToImprove,
        'how-to-register-a-stadia-account-from-unsupported-country': HowToRegisterAStadiaAccountFromUnsupportedCountry,
        'how-to-register-a-stadia-account': HowToRegisterAStadiaAccount,
        'how-to-access-stadia-from-unsupported-country-on-chrome-cast-ultra': HowToAccessStadiaFromUnsupportedCountryOnChromeCaseUltra,
         'how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv' : HowToAccessStadiaFromUnsupportedCountryOniOS
      }
  };
</script>
